import './story-audience-demographics.scss';

import StoryAudienceDemographics from './StoryAudienceDemographics';

export default StoryAudienceDemographics;
